import { history } from 'modules/navigator';
import 'normalize.css';
import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import OutdatedApp from '../../components/App';
import MegatronApp from '../megatron';
import PaymentApp from '../payment';
import SixshotApp from '../sixshot';
import ScorponokApp from '../scorponok';
import MainApp from '../main';
import BindPhone from '../main/bindPhone';
import SaleToolApp from '../saleTool';
import RentApp from '../rent';
// import Other from '../other';
import EswjApp from '../eswj'
import './index.scss';

class Router extends BrowserRouter {
  public history = history;
}


import Loadable from 'react-loadable';
const LoaderOther = Loadable({
  loader: () => import('../other').then(e=> e.default),
  loading() {
    return <div className='loading'></div>
  }
});  //按需加载，分包效果
// <Route exact path="/a/a1" component={LoaderOther} />


export default function App() {
  return (
    <Router>
      <OutdatedApp />
      <Route path="/payment" component={PaymentApp} />
      <Route path="/sixshot" component={SixshotApp} />
      <Route path="/megatron" component={MegatronApp} />
      <Route path="/scorponok" component={ScorponokApp} />
      <Route path="/saleTool" component={SaleToolApp} />
      <Route path="/rent" component={RentApp} />
      <Route path="/eswj" component={EswjApp} />
      <Route path="/main" component={MainApp} />
      <Route path="/bindPhone" component={BindPhone} />

      <Route path="/other" component={LoaderOther} />
    </Router>
  );
}
